/**
 * Formats a numeric currency amount according to ISO 4217 standards.
 * @param amount - The numeric amount to format
 * @param isoCode - The ISO 4217 currency code (e.g., 'CAD', 'USD').
 * @param locale - The locale string for formatting (defaults to 'en')
 * @returns Formatted currency string (e.g., "CAD 165.00")
 */
export const formatCurrency = (
  amount: number,
  isoCode: string,
  locale?: string,
): string => {
  const normalizedCode = isoCode.trim().toUpperCase()
  const resolvedLocale = locale ?? 'en'

  try {
    const formatter = new Intl.NumberFormat(resolvedLocale, {
      style: 'currency',
      currency: normalizedCode,
      currencyDisplay: 'code',
    })
    return formatter.format(amount)
  } catch (error) {
    // Fallback if the ISO code is invalid
    console.warn(
      `Invalid currency code: ${normalizedCode}. Falling back to numeric format.`,
    )
    return `${normalizedCode} ${amount.toFixed(2)}`
  }
}
